(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ChatBot", [], factory);
	else if(typeof exports === 'object')
		exports["ChatBot"] = factory();
	else
		root["ChatBot"] = factory();
})(self, function() {
return 